import api from '@/shared/api/client';

/**
 * Télémétrie des intégrations, réservée au super admin.
 *
 * Deux appels et pas un de plus. La vue d'ensemble est volontairement lourde côté
 * serveur — elle sonde Tuya, le disque et deux certificats TLS — donc elle
 * n'est PAS rechargée à chaque interaction : les vingt derniers appels d'une intégration
 * se demandent séparément, quand on ouvre sa carte.
 */

const lire = (chemin) => api.get(chemin).then((r) => r.data);

export const getTelemetrie = () => lire('/telemetrie');
export const getAppels = (cle) => lire(`/telemetrie/${cle}/appels`);

/** Vocabulaire fermé des sondes, tel que le backend le rend. */
export const SONDES = {
  joignable: { label: 'Joignable', teinte: 'bg-emerald-100 text-emerald-700' },
  actif: { label: 'Actif', teinte: 'bg-emerald-100 text-emerald-700' },
  interne: { label: 'Moteur interne', teinte: 'bg-slate-100 text-slate-700' },
  sandbox: { label: 'Bac à sable', teinte: 'bg-amber-100 text-amber-700' },
  simulation: { label: 'Simulation', teinte: 'bg-amber-100 text-amber-700' },
  mock: { label: 'Simulation', teinte: 'bg-amber-100 text-amber-700' },
  non_configure: { label: 'Non configuré', teinte: 'bg-slate-200 text-slate-700' },
  inactif: { label: 'Inactif', teinte: 'bg-slate-200 text-slate-700' },
  cles_refusees: { label: 'Clés refusées', teinte: 'bg-red-100 text-red-700' },
  injoignable: { label: 'Injoignable', teinte: 'bg-red-100 text-red-700' },
  inconnu: { label: 'Inconnu', teinte: 'bg-slate-200 text-slate-700' },
};

/**
 * Vocabulaire du heartbeat métier. `muet` est ROUGE et `inapplicable` est GRIS : c'est
 * toute la distinction qui rend la page lisible. Un service muet est une panne qu'aucun
 * error-handler ne verra ; un service inapplicable est un service qu'on a débranché
 * exprès. Les peindre pareil ferait qu'on n'y prête plus attention ni à l'un ni à l'autre.
 */
export const HEARTBEATS = {
  produit: { label: 'Produit', teinte: 'bg-emerald-100 text-emerald-700' },
  muet: { label: 'Muet', teinte: 'bg-red-100 text-red-700' },
  inapplicable: { label: 'Sans objet', teinte: 'bg-slate-100 text-slate-500' },
};

export const dateCourte = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
  } catch { return iso; }
};

/** « il y a 3 h 20 » — plus parlant qu'une date quand on cherche une panne en cours. */
export const depuis = (iso) => {
  if (!iso) return 'jamais';
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return iso;
  const minutes = Math.floor(ms / 60000);
  if (minutes < 1) return "à l'instant";
  if (minutes < 60) return `il y a ${minutes} min`;
  const heures = Math.floor(minutes / 60);
  if (heures < 24) return `il y a ${heures} h ${String(minutes % 60).padStart(2, '0')}`;
  const jours = Math.floor(heures / 24);
  return `il y a ${jours} j`;
};

export const fenetreLisible = (heures) => {
  if (!heures) return '';
  if (heures < 24) return `${heures} h`;
  return `${heures / 24} j`;
};
